import React from 'react';

// redux
import { connect } from 'react-redux';
import * as actions from 'actions';
import { bindActionCreators } from 'redux';
import { compose } from 'redux';


// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import CustomDropdown from "components/CustomDropdown/CustomDropdown.jsx";


import extendedFormsStyle from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.jsx";
import _ from 'lodash';

class OrgSelector extends React.Component {
  componentDidMount() {
    const { orgs } = this.props.org;
    if (!orgs) {
      this.props.getOrgsAction();
    }
  }
  render() {
    const { classes, org } = this.props;
    const { orgs = null, currentOrg = null } = org;
    const dropdownList = orgs ? orgs.map(org => org.data().기관명).filter(name => name) : [];
    const buttonText = orgs
      ? currentOrg
        ? currentOrg.data().기관명
        : "기관선택"
      : "Loading..."
    // console.log('dropdownList = ', dropdownList);
    return (
      <div style={{
        marginLeft: "26px",
        marginRight: "30px"
      }}>
        <CustomDropdown
          hoverColor="info"
          buttonText={buttonText}
          buttonProps={{
            round: true,
            fullWidth: true,
            style: { marginBottom: "0" },
            color: "info"
          }}
          dropdownHeader="조회하려는 기관을 선택하세요"
          dropdownList={dropdownList}
          onClick={(val) => {
            const org = _.find(orgs, (org) => org.data().기관명 === val);
            this.props.selectCurrentOrgAction(org);
            console.log('clicked : ', org.id);
          }}
        />
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    currentUser: state.auth.currentUser,
    currentRole: state.auth.currentRole,
    org: state.org,
  }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(actions, dispatch);
}

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withStyles(extendedFormsStyle),
)(OrgSelector);
